// NewOrganizationPage.js
import React, { useContext, useState } from 'react';

import Banner from '../../b2b-common/Banner';
import B2BDialog from '../../b2b-common/B2BDialog';
import { LoginContext } from '../../../App';
import { createOrganization } from '../../../services/b2b-users-apiService';

import './NewOrganizationPage.css';
import { generateClassName, generateTextField } from '../../b2b-common/helpers';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';

const NewOrganizationPage = () => {
    const [organizationName, setOrganizationName] = useState('');
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);

    const { loginData } = useContext(LoginContext);

    const handleOrganizationCreation = async () => {
        try {
            if (loginData) {
                const { accessToken } = loginData;
                await createOrganization(organizationName, accessToken);
                setOrganizationName('');
                setDialogError(null);
            }
        } catch (error) {
            console.error('Failed to create organization:', error.message);
            setDialogError('Failed to create organization: ' + error.message);
        } finally {
            setDialogOpen(true);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDialogError(null);
    };

    const buttonsConfig = [
        {
            label: 'Create Organization',
            disabledText: 'Create Organization',
            onClick: handleOrganizationCreation,
            color: 'secondary',
            variant: 'contained',
            key: '1',
        },
    ];

    return (
        <div className='new-organization-page'>
            <Banner message="Users Menu: Add new organization" />
            <B2BFormContainer title="New organization form" className="new-organization-form" orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
                {generateTextField("Name", organizationName, generateClassName("organization-search-form", "-field"), false, (e) => setOrganizationName(e.target.value), { required: true })}
            </B2BFormContainer>
            <B2BDialog
                open={isDialogOpen}
                onClose={handleDialogClose}
                title={dialogError ? 'Error Creating Organization' : 'Organization Created'}
            >
                <p>{dialogError || "The organization has been created successfully."}</p>
            </B2BDialog>
        </div>
    );
};

export default NewOrganizationPage;
